import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { IconComponent } from "../icon/icon.component";
import { NgClass } from "@angular/common";

@Component({
    selector: "rask-input-validation-icon",
    templateUrl: "./input-validation-icon.component.html",
    styleUrls: ["./input-validation-icon.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        IconComponent,
        NgClass
    ]
})
export class InputValidationIconComponent {
    @Input() isValid = false;
    @Input() text: string;
}
